/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, SCS, $) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 *
	 */

	'use strict';
	/*jshint smarttabs:true */

	var deparam = require('lib/vendor/jquery-deparam-patched').default;

	Module.TabNavigation = Module.extend({
		CHANNEL_GENERIC: 'TabNavigation',

		INDICATOR_HALF_WIDTH: 10,

		currentTabIndex: null,
		lastTracked: '',

		// @Overridable by skins
		on: function (callback) {
			var mod = this;
			mod.channel = mod.CHANNEL_GENERIC + SCS.utils.getUniqueIdOfElement(mod.$ctx);
			mod.name = mod.$ctx.data('name') || mod.channel;
			// FIXME: Is there a reason why we don’t use mod.$ctx.find('> .navigation-bar .tab-navigation-tab') and drop the filter?
			mod.tabs = mod.$ctx.find('.tab-navigation-tab').filter(function () {
				return mod.isResponsibleFor($(this)) && $(this).closest('.bottom-tab-links').length === 0;
			});
			mod.trackingEnabled = mod.$ctx.data('tracking-enabled') || false;
			// mod.track(mod.tabs.filter('.active'), true);
			mod.pageBackgroundContainer = $('.modPageBackground');
			mod.defaultTitle = $('.navigation-bar h1', mod.$ctx).eq(0).text();
			mod.activeIndicator = $('.indicator', mod.$ctx);
			mod.bottomBorderLeftItem = $('.border-bottom:eq(0) > div', mod.$ctx).eq(0);
			mod.initHandlers();
			mod.sandbox.subscribe(mod.CHANNEL_GENERIC, mod);
			mod.sandbox.subscribe(mod.channel, mod);
			mod.fire('startSubscription', [mod.CHANNEL_GENERIC]);
			$(window).resize(function () {
				mod.updateIndicatorWidth();
			});
			mod.hasMobileQtip = mod.$ctx.find('.modCallOut').length && SCS.utils.isMobilePage();

			callback();
		},

		// @Overridable by skins
		initHandlers: function () {
			var mod = this;
			mod.tabs.on('click', $.proxy(mod.tabClickedHandler, mod));
		},

		onSubscribe: function (data) {
			var mod = this,
				index = data.index;
			if (mod.isResponsibleFor(data.element, data.name, data.type === 'content')) {
				if (data.type === 'content') {
					data.subscribe(mod.channel, mod.name, index);
				} else {
					data.subscribe(mod.channel, mod.name);
				}
			}
		},

		isResponsibleFor: function (content, name, isTabContent) {
			var mod = this,
				isResponsible = mod.name === name || mod.$ctx.is(content.closest('.modTabNavigation'));
			if (isTabContent && isResponsible && content.closest('.modTabNavigation').is(content.parent().closest('.modTabNavigationContent').closest('.modTabNavigation'))) {
				return false;
			}
			return isResponsible;
		},

		// @Overridable by skins
		after: function () {
			var mod = this,
				hashValueStr = location.hash.substr(1),
				hashValues,
				activeTab = mod.tabs.filter('.active');

			if (hashValueStr) {
				hashValues = deparam(hashValueStr);
				var activatedByHash = false;
				mod.tabs.each(function () {
					var tab = $(this);
					var selector = tab.data('hash-selector');
					if (selector in hashValues) {
						activeTab = tab;
						activatedByHash = true;
						return false;
					}
				});
				if (!activatedByHash) {
					// Legacy handling
					mod.tabs.each(function () {
						var tab = $(this);
						if (tab.attr('data-index') === hashValueStr) {
							activeTab = tab;
							activatedByHash = true;
							return false;
						}
					});
				}
			}
			if (activeTab.length) {
				mod.moveActiveIndicator();
				mod.activateTab(activeTab);
			}
		},

		onActivateContent: function (data) {
			var mod = this;
			if (data.index) {
				mod.activateTab(mod.tabs.eq(data.index - 1));
			}
		},

		// @Overridable by skins
		tabClickedHandler: function (event) {
			var mod = this;
			event.preventDefault();
			var tab = $(event.currentTarget);
			if (tab.is('.active')) {
				return;
			}

			mod.activateTab(tab);
			mod.track(tab);
		},

		// @Overridable by skins
		activateTab: function (activatedTab) {
			var mod = this;
			var backgroundSettings = null;
			var index = activatedTab.data('index');
			var previouslyActiveTab = mod.tabs.filter('.active');

			if (previouslyActiveTab.data('use-custom-background')) {
				backgroundSettings = [];
			}
			previouslyActiveTab.removeClass('active');

			mod.currentTabIndex = index;
			mod.animateIndicator(activatedTab);
			activatedTab.addClass('active');

			$('.navigation-bar h1', mod.$ctx).eq(0).text(activatedTab.data('dynamic-title') ? activatedTab.data('dynamic-title') : mod.defaultTitle);

			if (activatedTab.data('use-custom-background')) {
				backgroundSettings = [
					activatedTab.data('background-image'),
					activatedTab.data('background-color'),
					activatedTab.data('background-repeat-x'),
					activatedTab.data('background-repeat-y')
				];
			}

			if (backgroundSettings !== null) {
				mod.pageBackgroundContainer.trigger('setBackground', backgroundSettings);
			}

			if(mod.hasMobileQtip) {
				$('.qtip-close').trigger('click');
			}

			mod.fire('activateTab', {
				index: index
			}, [mod.channel]);
		},

		track: function (element) {

			var mod = this;

			if (!mod.trackingEnabled || !element || element.length <= 0) {
				return;
			}

			var trackingName = element.data('tracking-name') || element.text();

			element.parents('.modTabNavigation').each(function (index) {
				element = $(this).find('a.tab-navigation-tab.active');
				var trackingText = element.data('tracking-name') || element.text();
				if (index === 0) {
					trackingName = trackingText;
				} else {
					trackingName = trackingText + '/' + trackingName;
				}
			});

			if (mod.lastTracked === trackingName) {
				return;
			} else {
				mod.lastTracked = trackingName;
				SCS.tracking.trackPartialPageView(trackingName);
			}

			// SCS.portal.datalayer.appendPagePath(trackingName);
			//if (!isInitialTracking) {
			// SCS.tracking.trackPartialPageView(trackingName);
			//}
		},

		animateIndicator: function () {
			if (!this.$ctx.hasClass('single-tab')) {
				this.makeAnimation(0, 12, $.proxy(this.moveActiveIndicator, this));
			}
		},

		makeAnimation: function (endValue, step, callback) {
			var mod = this,
				isIE = (mod.activeIndicator.css('backgroundPosition') === undefined),
				backgroundPosition = ( isIE ) ? mod.activeIndicator.css('background-position-y') : mod.activeIndicator.css('backgroundPosition').split(' ')[1],
				currentValue = parseInt(backgroundPosition, 10);

			var interval = setInterval(function () {
				if (typeof(currentValue) !== 'undefined' && (step > 0 && currentValue < endValue) || (step < 0 && currentValue > endValue)) {
					currentValue += step;
					if (isIE) {
						mod.activeIndicator.css('background-position-y', currentValue);
					}
					else {
						mod.activeIndicator.css('backgroundPosition', '0px ' + currentValue + 'px');
					}
				}
				else {
					clearInterval(interval);
					if (typeof(callback) === 'function') {
						callback();
					}
				}

			}, 10);
		},

		updateIndicatorWidth: function () {
			var mod = this,
				activeTab = this.tabs.filter('.active');

			if(!activeTab.length) {
				return;
			}

			var leftItemWidth = Math.floor(activeTab.position().left) + Math.floor((activeTab.width() / 2)) - this.INDICATOR_HALF_WIDTH;

			mod.bottomBorderLeftItem.width(leftItemWidth);
		},

		moveActiveIndicator: function () {
			var mod = this;
			if (!mod.$ctx.hasClass('single-tab')) {
				mod.updateIndicatorWidth();
				mod.makeAnimation(-120, -12);
			}
		}
	});

}(window.Tc.Module, window.SCS, window.Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.TabNavigation.js
// module id = 188
// module chunks = 0